import clsx from 'clsx';
import Link from 'next/link';
import styles from './EnterFlowFooter.module.css';

interface Props {
  variant?: 'V2' | undefined;
}

const EnterFlowFooter = (props: Props) => {
  const year = new Date().getFullYear();
  return (
    <footer
      className={clsx(
        styles.container,
        props.variant === 'V2' ? styles.variant2 : undefined,
      )}
    >
      <span className="daymadeTypographyXS">&copy; {year} DAYMADE LTD</span>
      <ul className="daymadeTypographySRegular">
        <li>
          <Link
            className="linkReset"
            href="https://daymade.zendesk.com/hc/en-gb"
            rel="noopener noreferrer"
            target="_blank"
          >
            Help Center
          </Link>
        </li>
        <li>
          <Link className="linkReset" href="/contact-us">
            Contact Us
          </Link>
        </li>
      </ul>
    </footer>
  );
};

export default EnterFlowFooter;
